var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrespondents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 131,
    viewBox: "0 0 139 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1422 66.8667C52.4641 66.8667 61.6422 57.3826 61.6422 45.6833C61.6422 33.9841 52.4641 24.5 41.1422 24.5C29.8204 24.5 20.6422 33.9841 20.6422 45.6833C20.6422 57.3826 29.8204 66.8667 41.1422 66.8667Z",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0423 107.649C78.0423 88.1448 62.1618 72.3334 42.572 72.3334H39.7127C20.1228 72.3334 4.24231 88.1448 4.24231 107.649V127L78.0423 107.649ZM78.0423 107.649V127",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8589 46.3667C109.558 46.3667 119.042 36.8826 119.042 25.1833C119.042 13.4841 109.558 4 97.8589 4C86.1596 4 76.6755 13.4841 76.6755 25.1833C76.6755 36.8826 86.1596 46.3667 97.8589 46.3667Z",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0089 76.416C67.5869 62.1819 81.0493 51.8333 96.956 51.8333H99.8269C119.497 51.8333 135.442 67.6447 135.442 87.1493V106.5",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 112.698L73.8175 93.7223",
    stroke: "#000000",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrespondents);
export default __webpack_public_path__ + "static/media/correspondents.7eba5eaba4778c01c1239c35dc98967b.svg";
export { ForwardRef as ReactComponent };